(function(_){
    'use strict';
    _['RESTAURANT.KEY']='Page';
    _['RESTAURANT.CATEGORIES'] = 'Categories';
    _['RESTAURANT.NO-CONTENT'] = 'This module is empty';
    _['RESTAURANT.NO-CONTENT-FOODS'] = 'This category is empty';
    _['RESTAURANT.FROM'] = 'From';
    _['RESTAURANT.ADD'] = 'Add';
    _['RESTAURANT.VIEW_DETAIL'] = 'Show detail';
    _['RESTAURANT.GO-BACK-RESTAURANT'] = 'Go back categories';
    _['RESTAURANT.GO-BACK-CATEGORY'] = 'Go back category';
    _['RESTAURANT.PRICE'] = 'Price';
    _['RESTAURANT.EXPAND'] = 'Show description';
    _['RESTAURANT.COLLAPSE'] = 'Hide';

}(translations['en']));












// WEBPACK FOOTER //
// ./src/app/modules/restaurant/lang/restaurant-lang_en.js